<div class="dashboardWidgetContainer">
    <h2>{{ 'dashboard.scheduledReports.label' | translate }}</h2>
    @if (data && data.length > 0) {
        @if (columns && data) {
            <div class="gridWrapper">
                <app-data-grid [columns]="columns" [data]="data" />
            </div>
        }
    } @else {
        <div class="noDataText">
            <p>{{ 'dashboard.scheduledReports.noData' | translate }}</p>
        </div>
    }
    <footer>
        <button type="button" class="button primary hasIcon" (click)="openAddScheduledReportModal()">
            <i class="far fa-plus iconSmall"></i>
            {{ 'dashboard.scheduledReports.add' | translate }}
        </button>
    </footer>
</div>
